import type {
    HTMLAttributes,
    TableHTMLAttributes,
    ThHTMLAttributes,
    TdHTMLAttributes,
} from 'react';
import { cn } from '@/ui/lib/utils';
import './table.css';

const TableHeader = ({ className, ...props }: HTMLAttributes<HTMLTableSectionElement>) => {
    return <thead className={cn('table__header', className)} {...props} />;
};

const TableBody = ({ className, ...props }: HTMLAttributes<HTMLTableSectionElement>) => {
    return <tbody className={cn('table__body', className)} {...props} />;
};

const TableFooter = ({ className, ...props }: HTMLAttributes<HTMLTableSectionElement>) => {
    return <tfoot className={cn('table__footer', className)} {...props} />;
};

const TableRow = ({ className, ...props }: HTMLAttributes<HTMLTableRowElement>) => {
    return <tr className={cn('table__row', className)} {...props} />;
};

const TableHead = ({ className, ...props }: ThHTMLAttributes<HTMLTableCellElement>) => {
    return <th className={cn('table__head', className)} {...props} />;
};

const TableCell = ({ className, ...props }: TdHTMLAttributes<HTMLTableCellElement>) => {
    return <td className={cn('table__cell', className)} {...props} />;
};

const TableCaption = ({ className, ...props }: HTMLAttributes<HTMLTableCaptionElement>) => {
    return <caption className={cn('table__caption', className)} {...props} />;
};

const TableBase = ({ className, ...props }: TableHTMLAttributes<HTMLTableElement>) => {
    return <table className={cn('table', className)} {...props} />;
};

type TableComposite = typeof TableBase & {
    Header: typeof TableHeader;
    Body: typeof TableBody;
    Footer: typeof TableFooter;
    Row: typeof TableRow;
    Head: typeof TableHead;
    Cell: typeof TableCell;
    Caption: typeof TableCaption;
};

export const Table = TableBase as TableComposite;

Table.Header = TableHeader;
Table.Body = TableBody;
Table.Footer = TableFooter;
Table.Row = TableRow;
Table.Head = TableHead;
Table.Cell = TableCell;
Table.Caption = TableCaption;
